import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Contractor } from '../../domain/contractor';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';
import { CONTRACTORS_PATH } from '../paths';

export const useRemoveContractorRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const removeContractor = useMutation({
        mutationFn: (contractorId: string) => removeContractorFunction(contractorId),
        onSuccess: (removedContractorId: string) => {
            queryClient.removeQueries({ queryKey: ['contractors', { id: removedContractorId }] });
            queryClient.setQueryData(['contractors'], (originalContractors?: Array<Contractor>) => {
                if (!originalContractors) {
                    return;
                }
                return originalContractors.filter((originalContractor) => originalContractor.id !== removedContractorId);
            });
        },
    });

    const removeContractorFunction = async (contractorId: string) => {
        const token = await getJwtToken();

        const response = await fetch(`${BACKEND_URL}/${CONTRACTORS_PATH}/${contractorId}`, {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw await response.json().catch(() => ({}));
        }

        return contractorId;
    };

    return {
        removeContractor: (contractorId: string) => removeContractor.mutateAsync(contractorId),
        isRemovingContractorPending: removeContractor.isPending,
    };
};
